<template>
	<v-app id="inspire">
		<!-- 导航栏 -->
		<v-container class="py-0">
			<v-app-bar height="88" class="g-pa-sm-0 elevation-0" color="#00000000">
				<v-app-bar-nav-icon @click.stop="drawer = !drawer" class="g-d-sm-block d-md-none mr-2"></v-app-bar-nav-icon>
				<v-toolbar-title class="pl-0" style="overflow: inherit">
					<v-avatar tile>
						<img src="../../assets/img/portal-logo.png" alt="数智残联·协同端" />
					</v-avatar>
					<div class="d-inline-block ml-4 primary--text g_v-align-top">
						<span class="headline font-weight-bold">{{ $vtk.env.VUE_APP_HEAD }}</span>
						<span class="text-md-caption g-text-sm-body-2 d-block">Socialized Disability Assistance Service Platform</span>
					</div>
				</v-toolbar-title>
				<v-spacer />
				<v-btn rounded elevation="0" href="#/login" text>员工登录</v-btn>
				<v-btn rounded elevation="0" class="g-d-sm-none" :href="$vtk.env.VUE_APP_LOGIN" text>法人登录</v-btn>
				<v-btn icon elevation="0" class="g-d-sm-none" style="width: 36px; height: 36px" @click.stop="$vuetify.theme.dark = !$vuetify.theme.dark"><v-icon>mdi-theme-light-dark</v-icon></v-btn>
			</v-app-bar>
		</v-container>

		<!-- 侧滑菜单栏 -->
		<v-navigation-drawer v-model="drawer" absolute temporary>
			<v-list-item class="py-2">
				<v-list-item-avatar size="36">
					<v-img src="../../assets/img/portal-logo.png"></v-img>
				</v-list-item-avatar>
				<v-list-item-content>
					<v-list-item-title class="title font-weight-medium primary--text">{{ $vtk.env.VUE_APP_HEAD }}</v-list-item-title>
				</v-list-item-content>
			</v-list-item>
			<v-divider></v-divider>
			<v-list nav>
				<v-list-item v-for="(item, index) in navData" :key="index" link :href="item.href">
					<v-list-item-icon class="pa-1" :class="[item.sback, 'rounded-lg text-center justify-center mr-3']">
						<v-icon>{{ item.icon }}</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>{{ item.title }}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>
		<v-main>
			<div :class="$vuetify.theme.dark ? 'grey darken-4' : 'bg-blue'">
				<v-container class="portal g-pa-sm-4">
					<!-- banner -->
					<v-row class="px-6 g-px-sm-0">
						<v-col cols="12" md="6" sm="12" style="position: relative">
							<p class="text-lg-h3 text-md-h4 g-text-sm-h5 font-weight-bold mt-lg-12 pt-lg-8 g-mt-sm-10 mt-md-10 mb-6">社会化助残服务</p>
							<p class="grey--text">秒审直达，秒办告知，多终端一键登录，无缝对接零等待</p>
							<v-btn rounded elevation="0" class="grad-blue-1 white--text mt-2 g-d-sm-none" :href="$vtk.env.VUE_APP_LOGIN" large>法人登录</v-btn>
							<v-btn rounded elevation="0" outlined color="blue" class="ml-3 mt-2 g-d-sm-none" href="#/login" large>员工登录</v-btn>
						</v-col>
						<v-col cols="12" md="6" sm="12" class="text-right pt-0 g-pr-sm-0">
							<img src="../../assets/img/portal1.png" alt="" class="g-img-sm-lg" />
						</v-col>
					</v-row>
				</v-container>
			</div>
			<div :class="$vuetify.theme.dark ? 'black' : ''">
				<v-container class="portal g-pa-sm-4">
					<!-- 轮播图介绍 -->
					<v-row class="px-6 pt-6 pb-8 g-px-sm-4">
						<v-col cols="12" md="12" sm="12">
							<v-carousel cycle height="400" hide-delimiter-background show-arrows-on-hover light :show-arrows="false" delimiter-icon="mdi-minus">
								<v-carousel-item>
									<v-sheet height="100%">
										<v-row class="fill-height" :class="$vuetify.theme.dark ? 'black white--text' : ''">
											<v-col cols="12" md="6" sm="12">
												<v-img src="../../assets/img/portal5.png" class="ma-auto" max-width="650" height="80%" contain></v-img>
											</v-col>
											<v-col cols="12" md="6" sm="12">
												<p class="size-28 g-text-sm-h5 font-weight-bold mb-md-6">移动服务</p>
												<p><v-icon class="mr-3" :color="$vuetify.theme.dark ? 'white' : ''">mdi-cellphone-charging</v-icon>高效便捷，让服务更加简单</p>
												<p><v-icon class="mr-3" :color="$vuetify.theme.dark ? 'white' : ''">mdi-chart-donut-variant</v-icon>智能互联，引领未来生活方式</p>
												<p><v-icon class="mr-3" :color="$vuetify.theme.dark ? 'white' : ''">mdi-cellphone-wireless</v-icon>掌握在手，服务无忧，移动时代新体验</p>
											</v-col>
										</v-row>
									</v-sheet>
								</v-carousel-item>
								<v-carousel-item>
									<v-sheet height="100%">
										<v-row class="fill-height" :class="$vuetify.theme.dark ? 'black white--text' : ''">
											<v-col cols="12" md="6" sm="12">
												<v-img src="../../assets/img/urole_dsh.png" class="mx-auto" max-width="600"></v-img>
											</v-col>
											<v-col cols="12" md="6" sm="12">
												<p class="size-28 g-text-sm-h5 font-weight-bold mb-md-6">应用开放</p>
												<p><v-icon class="mr-3" :color="$vuetify.theme.dark ? 'white' : ''">mdi-monitor-cellphone-star</v-icon>创新无界，应用无缝对接</p>
												<p><v-icon class="mr-3" :color="$vuetify.theme.dark ? 'white' : ''">mdi-microsoft-internet-explorer</v-icon>智能时代，大数据引领未来趋势</p>
												<p><v-icon class="mr-3" :color="$vuetify.theme.dark ? 'white' : ''">mdi-google-chrome</v-icon>定制软件，应用开发助力企业飞跃。</p>
											</v-col>
										</v-row>
									</v-sheet>
								</v-carousel-item>
								<v-carousel-item>
									<v-sheet height="100%">
										<v-row class="fill-height" :class="$vuetify.theme.dark ? 'black white--text' : ''">
											<v-col cols="12" md="6" sm="12">
												<v-img src="../../assets/img/portal3.png" class="mx-auto" max-width="420"></v-img>
											</v-col>
											<v-col cols="12" md="6" sm="12">
												<p class="size-28 g-text-sm-h5 font-weight-bold mb-md-6">职工申报</p>
												<p><v-icon class="mr-3" :color="$vuetify.theme.dark ? 'white' : ''">mdi-google-chrome</v-icon>便捷高效，告别繁琐</p>
												<p><v-icon class="mr-3" :color="$vuetify.theme.dark ? 'white' : ''">mdi-file-send-outline</v-icon>一键申报，轻松管理，福利尽在掌握</p>
												<p><v-icon class="mr-3" :color="$vuetify.theme.dark ? 'white' : ''">mdi-image-filter-tilt-shift</v-icon>提升效率，优化流程，助力残疾人事业</p>
											</v-col>
										</v-row>
									</v-sheet>
								</v-carousel-item>

								<v-carousel-item>
									<v-sheet height="100%">
										<v-row class="fill-height" :class="$vuetify.theme.dark ? 'black white--text' : ''">
											<v-col cols="12" md="6" sm="12">
												<v-img src="../../assets/img/portal2.png" class="ma-auto" height="80%" contain></v-img>
											</v-col>
											<v-col cols="12" md="6" sm="12">
												<p class="size-28 g-text-sm-h5 font-weight-bold mb-md-6">辅具智配</p>
												<p><v-icon class="mr-3" :color="$vuetify.theme.dark ? 'white' : ''">mdi-monitor-cellphone-star</v-icon>一键配置，无需等待</p>
												<p><v-icon class="mr-3" :color="$vuetify.theme.dark ? 'white' : ''">mdi-chat-processing-outline</v-icon>消息通知实时更新，不漏一条</p>
												<p><v-icon class="mr-3" :color="$vuetify.theme.dark ? 'white' : ''">mdi-chart-donut</v-icon>快捷应用，一键直达，告别繁琐</p>
											</v-col>
										</v-row>
									</v-sheet>
								</v-carousel-item>
							</v-carousel>
						</v-col>
					</v-row>
				</v-container>
			</div>
			<v-footer class="caption text-center" style="z-index: 6; border-top: #d7d7d7ba 1px solid" fixed padless>
				<v-container>
					{{ $vtk.env.VUE_APP_FOOT }}
				</v-container>
			</v-footer>
		</v-main>
	</v-app>
</template>

<script>
export default {
	name: "AdminIndex",
	data() {
		return {
			colors: ["indigo", "warning", "pink darken-2", "red lighten-1", "deep-purple accent-4"],
			drawer: false,
			navData: [
				{
					icon: "mdi-home-plus",
					title: "首页",
					sback: "grad-orange",
				},
				{
					icon: "mdi-account-heart",
					title: "服务需求",
					sback: "grad-green",
				},
				{
					icon: "mdi-newspaper-variant",
					title: "新闻公告",
					sback: "grad-cyan",
				},
				{
					icon: "mdi-earth",
					title: "企业登录",
					sback: "grad-blue",
					href: this.$vtk.env.VUE_APP_LOGIN,
				},
				{
					icon: "mdi-account-circle",
					title: "用户登录",
					sback: "grad-green",
				},
			],
		};
	},
	mounted() {},
	methods: {},
};
</script>

<style>
.grad-blue-1 {
	background: linear-gradient(90deg, #70c6f8 0%, #3d94ef 100%);
}
.bg-blue {
	background: #f9fcff !important;
}

.portal .txt {
	position: absolute;
	bottom: 0px;
	left: 0;
}
.theme--light.v-footer {
	background: #ffffff;
}
</style>
